const CountriesData = {
  countries: [
    {
      language: "Arabic",
      iso: "ar",
      flag: "🇸🇦",
    },
    {
      language: "English",
      iso: "en",
      flag: "🇬🇧",
    },
    {
      language: "Urdu",
      iso: "ur",
      flag: "🇵🇰",
    },
    {
      language: "Indonesian",
      iso: "id",
      flag: "🇮🇩",
    },
    {
      language: "Turkish",
      iso: "tr",
      flag: "🇹🇷",
    },
    {
      language: "Malay",
      iso: "ms",
      flag: "🇲🇾",
    },
    {
      language: "Afrikaans",
      iso: "af",
      flag: "🇿🇦",
    },
    {
      language: "Armenian",
      iso: "hy",
      flag: "🇦🇲",
    },
    {
      language: "Azerbaijani",
      iso: "az",
      flag: "🇦🇿",
    },
    {
      language: "Belarusian",
      iso: "be",
      flag: "🇧🇾",
    },
    {
      language: "Bosnian",
      iso: "bs",
      flag: "🇧🇦",
    },
    {
      language: "Bulgarian",
      iso: "bg",
      flag: "🇧🇬",
    },
    {
      language: "Catalan",
      iso: "ca",
      flag: "🇪🇦",
    },
    {
      language: "Chinese",
      iso: "zh",
      flag: "🇨🇳",
    },
    {
      language: "Croatian",
      iso: "hr",
      flag: "🇭🇷",
    },
    {
      language: "Czech",
      iso: "cs",
      flag: "🇨🇿",
    },
    {
      language: "Danish",
      iso: "da",
      flag: "🇩🇰",
    },
    {
      language: "Dutch",
      iso: "nl",
      flag: "🇳🇱",
    },

    {
      language: "Estonian",
      iso: "et",
      flag: "🇪🇪",
    },
    {
      language: "Finnish",
      iso: "fi",
      flag: "🇫🇮",
    },
    {
      language: "French",
      iso: "fr",
      flag: "🇫🇷",
    },
    {
      language: "Galician",
      iso: "gl",
      flag: "🇪🇸",
    },
    {
      language: "German",
      iso: "de",
      flag: "🇩🇪",
    },
    {
      language: "Greek",
      iso: "el",
      flag: "🇬🇷",
    },
    {
      language: "Hindi",
      iso: "hi",
      flag: "🇮🇳",
    },
    {
      language: "Hungarian",
      iso: "hu",
      flag: "🇭🇺",
    },
    {
      language: "Icelandic",
      iso: "is",
      flag: "🇮🇸",
    },

    {
      language: "Italian",
      iso: "it",
      flag: "🇮🇹",
    },
    {
      language: "Japanese",
      iso: "ja",
      flag: "🇯🇵",
    },
    {
      language: "Kannada",
      iso: "kn",
      flag: "🇮🇳",
    },
    {
      language: "Kazakh",
      iso: "kk",
      flag: "🇰🇿",
    },
    {
      language: "Korean",
      iso: "ko",
      flag: "🇰🇷",
    },
    {
      language: "Latvian",
      iso: "lv",
      flag: "🇱🇻",
    },
    {
      language: "Lithuanian",
      iso: "lt",
      flag: "🇱🇹",
    },
    {
      language: "Macedonian",
      iso: "mk",
      flag: "🇲🇰",
    },

    {
      language: "Marathi",
      iso: "mr",
      flag: "🇮🇳",
    },
    {
      language: "Maori",
      iso: "mi",
      flag: "🇳🇿",
    },
    {
      language: "Nepali",
      iso: "ne",
      flag: "🇳🇵",
    },
    {
      language: "Norwegian",
      iso: "no",
      flag: "🇳🇴",
    },
    {
      language: "Persian",
      iso: "fa",
      flag: "🇮🇷",
    },
    {
      language: "Polish",
      iso: "pl",
      flag: "🇵🇱",
    },
    {
      language: "Portuguese",
      iso: "pt",
      flag: "🇵🇹",
    },
    {
      language: "Romanian",
      iso: "ro",
      flag: "🇷🇴",
    },
    {
      language: "Russian",
      iso: "ru",
      flag: "🇷🇺",
    },
    {
      language: "Serbian",
      iso: "sr",
      flag: "🇷🇸",
    },
    {
      language: "Slovak",
      iso: "sk",
      flag: "🇸🇰",
    },
    {
      language: "Slovenian",
      iso: "sl",
      flag: "🇸🇮",
    },
    {
      language: "Spanish",
      iso: "es",
      flag: "🇪🇸",
    },
    {
      language: "Swahili",
      iso: "sw",
      flag: "🇰🇪",
    },
    {
      language: "Swedish",
      iso: "sv",
      flag: "🇸🇪",
    },
    {
      language: "Tagalog",
      iso: "tl",
      flag: "🇵🇭",
    },
    {
      language: "Tamil",
      iso: "ta",
      flag: "🇮🇳",
    },
    {
      language: "Thai",
      iso: "th",
      flag: "🇹🇭",
    },

    {
      language: "Ukrainian",
      iso: "uk",
      flag: "🇺🇦",
    },

    {
      language: "Vietnamese",
      iso: "vi",
      flag: "🇻🇳",
    },
    {
      language: "Welsh",
      iso: "cy",
      flag: "🏴",
    },
  ],
}

export default CountriesData
